import React,{ useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { observer } from "mobx-react-lite";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useEditData } from "../../../hooks/useEditData";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import FormCheckbox from '../../Generic/FormCheckbox';
import { useSetMenu } from "../../../hooks/useSetMenu";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import * as yup from "yup";
import FormSelect from '../../Generic/FormSelect';

const Edit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { mainStore } = useStore();
    const axiosPrivate = useAxiosPrivate();
    const { t } = useTranslation();
    useSetMenu(mainStore.SubcategoryMenuType, mainStore.SubcategoryMenuNo);
    const schema = yup.object({
        name: yup
            .string()
            .required(t('requiredField'))
            .max(250, t('maxLength', { max: 250 })),
        categoryId: yup.string().required(t("selectRequired")),
    });

    const { register, handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(schema) });
    const onSubmit = data => updateData(data);

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const additionalDataFetch = async (subcategoryData) => {
        try {
            const categoriesResponse = await axiosPrivate.get("/Categories/SelectOptions");
            setCategories(categoriesResponse.data);
            const selected = categoriesResponse.data.find(c => c.value === subcategoryData.categoryId.toString());
            setSelectedCategory(selected);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleCategoryChange = selectedOption => {
        setSelectedCategory(selectedOption);

        setValue("categoryId", selectedOption.value, { shouldValidate: true });
    };

    const { notFound, updateData } = useEditData(axiosPrivate, "/Subcategories", id, setValue, navigate,additionalDataFetch);

    const goToList = () => {
        navigate("/Subcategory/List");
    };

    if (notFound) {
        return <div className="not-found-myDiv">
            <div className="not-found-container">
                <div className="not-found-content">
                    <h1>{t("pageNotFoundTitle")}</h1>
                    <p>{t("noDataWithIdMessage")}</p>
                    <button onClick={goToList} className="btn btn-primary">
                        {t("goTo") + " " + t("list") + " " + t("subcategories")}
                    </button>
                </div>
            </div>
        </div>;
    }

    return (
        <FormLayout title={t("subcategoryEditTitle")} onSubmit={handleSubmit(onSubmit)} onCancel={() => navigate(-1)}>
            <FormSelect label="category" name="categoryId" options={categories} value={selectedCategory} onChange={handleCategoryChange} register={register} errors={errors} />
            <FormInput label="subcategory" name="name"  register={register} errors={errors} />
            <FormCheckbox label="isActive" register={register} name="isActive" colSize={4} />
        </FormLayout>
    );
};

export default observer(Edit);